module.exports = __webpack_public_path__ + "media/loading.70e4f5a0.mp4";